export default "__VITE_ASSET__4d961ded__"